import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateSchedulerPageConfig as UpdateSchedulerPageConfigMutation,
    UpdateSchedulerPageConfigVariables as UpdateSchedulerPageConfigVariables,
    PageConfigUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_SCHEDULER_PAGE_CONFIG from '../mutations/update-scheduler-page-config.graphql';

export const useUpdateSchedulerPageConfig = (): {
    updateSchedulerPageConfig: (arg1: PageConfigUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateSchedulerPageConfig, {loading, error}] = useMutation<
        UpdateSchedulerPageConfigMutation,
        UpdateSchedulerPageConfigVariables
    >(UPDATE_SCHEDULER_PAGE_CONFIG);

    return {
        updateSchedulerPageConfig: (input: PageConfigUpdateInput) =>
            updateSchedulerPageConfig({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
